import { useAppSelector } from 'app/hooks'
import BC from 'components/Breadcrumbs'
import Layout from 'components/Layout'
import { Fragment } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { authRoutes, privateRoutes, publicRoutes } from './routes'

function App() {
  const auth = useAppSelector((s) => s.UI.auth)
  const statusUI = useAppSelector((s) => s.UI.status)
  const location = useLocation()
  const from = (location.state as any)?.from?.pathname || '/'
  return (
    <Routes>
      {privateRoutes.map((v, i) => {
        const Wrap = v.useLayout ? Layout : Fragment
        return (
          <Route
            key={i}
            path={v.path}
            element={
              <Wrap>
                {statusUI !== 'init' ? (
                  auth ? (
                    <>
                      <BC />
                      <v.element />
                    </>
                  ) : (
                    <Navigate to="/login" state={{ from: location }} replace />
                  )
                ) : (
                  <h2>Loading...</h2>
                )}
              </Wrap>
            }
          />
        )
      })}
      {authRoutes.map((v, i) => {
        const Wrap = v.useLayout ? Layout : Fragment
        return (
          <Route
            key={i}
            path={v.path}
            element={
              <Wrap>
                {statusUI !== 'init' ? (
                  !auth ? (
                    <v.element />
                  ) : (
                    <Navigate to={from} replace />
                  )
                ) : (
                  <h2>Loading...</h2>
                )}
              </Wrap>
            }
          />
        )
      })}
      {publicRoutes.map((v, i) => {
        const Wrap = v.useLayout ? Layout : Fragment
        return (
          <Route key={i} path={v.path} element={<Wrap>{<v.element />}</Wrap>} />
        )
      })}
    </Routes>
  )
}

export default App
